export default __webpack_public_path__ + "static/project-start1-1144cf3a1b18070155dc90c8a7f97091.png";